import { SidebarTrigger } from '@/ui/design-system/components/ui/sidebar';
import { Text } from '@/ui/design-system/components';
import { useParams } from 'react-router-dom';

function ReportEdit() {
    const { reportId } = useParams();
    return (
        <div>
            <div className="flex items-center gap-3 px-4 py-3 border-b border-gray-200">
                <SidebarTrigger className="md:hidden" />
                <Text as="span" size="md" className="font-semibold">
                    Edit report
                </Text>
            </div>
            <div className="px-5 py-8">
                <Text color="muted">
                    Editing report {reportId} coming soon.
                </Text>
            </div>
        </div>
    );
}

export default ReportEdit;
